<template>
    <div class="netflixtrending">
        <h2 class="netflix-trending-header">Netflix trending</h2>
        <!--   netflixtrending   start -->
        <div class="trending">
        <div class="netflix-trending trendsection" ref="users">
          
            <!-- <div class="leftarrow" v-on:click="leftarrow()"><img src="../images/chevron-left-solid.svg"></div>
            <div class="rightarrow" v-on:click="rightarrow()"><img src="../images/chevron-right-solid.svg"></div> -->
            <div class="netflex trend" v-for=" (trending,index) in netflixtrending"  v-bind:key="index">
                   
                    
                <div class="netflix-original-images">
                  <div class="netflix-original-images mediumimage">
                        
                    <img :src="`https://image.tmdb.org/t/p/original`+`${trending.backdrop_path}`" alt="images">
                    <p> {{ trending.original_name}} </p>
                        <div class="desc-part">
                            <div class="icon">
                                <img src="../images/play-solid.svg">
                                <img src="../images/plus-circle-solid.svg">
                                <img src="../images/thumbs-up-solid.svg">
                                <img src="../images/thumbs-down-solid.svg">
                            </div>
                            <div class="desc-sec">
                                <span class="match" style="color:green">{{trending.vote_average}}% Match</span>
                                <span>{{ trending.overview }}</span>
                            </div>
                        </div>
                   </div>    
                </div>
            </div>
        </div>
        </div>
 <!--   netflixtrending  end -->
    </div>
</template>

<script>
import axios from 'axios';
const API_KEY = "c20644006c1a56f0c5eca8d53b6ccf4e";
//baseurl = "https://image.tmdb.org/t/p/original/";
export default {
    components:{
             
        },
    data(){
        return{
              netflixtrending:[], 
        }
    },
    created(){
            // trending
          axios.get(`https://api.themoviedb.org/3/trending/all/week?api_key=${API_KEY}&language=en-US`)
            .then(trendings => {
                   console.log('trending');
            console.log(trendings.data.results)
            console.log('trending');
            this.netflixtrending = trendings.data.results;
            })
        },
        leftarrow(){
            var netflixpopularslider = document.querySelector(".netflixtrending");
             netflixpopularslider.style.transform = "translate(-10%)";
          netflixpopularslider.style.transition = "1.4s all linear";
            var leftarrow = document.querySelector(".leftarrow");
           netflixpopularslider.appendChild(netflixpopularslider.firstElementChild);
           netflixpopularslider.style.transform = "translate(0)";
            
        },
        rightarrow(){
          
             var netflixpopularslider = document.querySelector(".netflixtrending");
             netflixpopularslider.style.transition = "1.4s all linear";
            netflixpopularslider.appendChild(netflixpopularslider.firstChild);
        
         
        },
        methods:{

        }
}
</script>


<style scoped>
.netflixtrending{
    margin-top: -21vw;
    margin-bottom: -17vw;
}
.netflix-trending::-webkit-scrollbar{
    display: none;
}
 .netflix-trending{
    display: flex;
     overflow-x: scroll;
        padding: 3vw 0 20vw 0;
            margin-top: -5vw;
}
  
.netflex{
       display: flex;
       flex-wrap: wrap;
       padding: 3vw 0 0vw 0;
   }
 .netflix-original-images{
       width:15vw;
       height:10vw;
       margin-left: 0.2vw;
       transition: transform .3s;
       transform: scale(1);   
   }
    .netflix-original-images:hover{
          transform: scale(1.2);
        z-index: 5000;
    }
    .trend:hover .desc-part{
        visibility: visible;
    }
   .netflix-original-images img{
        height: 100%;
        width: 100%;
        object-fit: contain;
        object-position: center;
       }
   .netflix-original-images p{
    top: 20%;
    position: absolute;
    transform: translateY(-20%);
        width: 100%;
    font-size: 1vw;
    text-align: center;
    font-family: 'Rock Salt', cursive;
   }
.netflix-trending-header{
   margin-top: 0vw;
   color: white;
}
.desc-part{
    color: white;
    height:auto;
    background-color:black;
    z-index: -10;
    transition: 0.1s ease-in;
    visibility: hidden;
    margin-top: -2vw;
  }
  .desc-part .icon{
   padding: 20px;
   overflow: hidden;
   display: flex;
   margin-top: 1vw;
  }
   .desc-part .icon img{
      height: 1vw;
      width: 1vw;
      border:1px solid white;
      border-radius: 50%;
      padding: 0.5vw;
      margin-left: 10px;
  }
   .leftarrow,.rightarrow{
      color:white;
  }
  .leftarrow{
  z-index: 50;
     position: absolute;
    height: max-content;
    margin-top: 80px;
    width: 30px;
    visibility: hidden;
  }
  .rightarrow{
      z-index: 50;
     position: absolute; 
    right: 77px;
    margin-top: 80px;
    width: 30px;
    visibility: hidden;
  }
  .netflix-origional:hover .leftarrow,
  .netflix-origional:hover .rightarrow{
   visibility: visible;
  }
  .desc-sec{
      padding: 0 1vw 1vw 1vw;
  }
  .desc-sec span{
      font-size: 10px;
      color: white;
      margin-top: 0vw;
  }
  .match{
      color:green;
      display: block;
      font-weight: 700;
  }
</style>